import { Injector, NgZone } from "@angular/core";
import { shareReplay, Subject } from "rxjs";
import { constants } from "src/app/config/constant";
import { LogService } from "../log.service";
import { SignalrService } from "../signalr.service";

export class ModuleService {
  public CompIdx = 0;
  public DeviceManagerInterface = '';
  public hubProxy: any;
  private moduleId: string;
  public connected: boolean = false;
  private deferred_list: {
    name: string,
    parameters: any[],
    resolve: any,
    reject: any
  }[] = [];
  private listeners: any = [];
  private mocked_listeners: any = [];
  private mocked_once_listeners: any = [];
  private once_listeners: any = [];
  public signalR: SignalrService;
  public ngZone: NgZone;
  public config: constants;
  public logger: LogService;
  public onConnect = new Subject<boolean>();
  public connection$ = this.onConnect.asObservable().pipe(shareReplay());
  public unavailable = false;

  constructor(moduleId: string, injector: Injector) {
    this.moduleId = moduleId;

    this.logger = injector.get(LogService);
    this.config = injector.get(constants);
    this.signalR = injector.get(SignalrService);
    this.ngZone = injector.get(NgZone);

    // this.signalR.connect().then(() => {
    //   this.signalR.getComponent(this).then((c: any) => {
    //     this.onConnect.next(c)
    //   })
    // }).catch((e) => {
    //   this.logger.log('Failed to connect')
    //   this.logger.log(e)
    // })
    this.connection$.subscribe((connected) => {
      if (connected) {
      }
    })
  }

  public getModuleId() {
    return this.moduleId;
  }

  attachListeners() {
    this.signalR.log('AppLog_Info', { message: "attaching events", metadata: { moduleId: this.moduleId } });
    this.listeners = this.listeners.filter((args: any, i: number) => {
      this.on.call(this, args.e, args.cb)
      return false
    })

    this.once_listeners = this.once_listeners.filter((args: any, i: number) => {
      this.once.call(this, args.e, args.cb)
      return false
    })
  }

  public connect(): Promise<any> {
    let connect = {
      "IO_Module": "iOModule_Connect",
      "Barcode_Scanner": "barcodeScanner_Connect",
      "Bill_Dispenser": "billDispenser_Connect",
      "Bill_Acceptor": "billAcceptor_Connect",
      "PinPad": "pinPad_Connect",
      "MagstripeReader": "MagstripeReader_Connect",
    }[this.moduleId] || ""
    if (connect) {
      return new Promise((resolve, reject) => {
        this.logger.log('connecting ', this.getModuleId())
        if (!this.config.KIOSK_ENABLED) {
          this.connected = true;
          resolve(true)
          return
        }
        // this.on(['on',connect.replace('_','').split('')])
        // this.callMethodSync(connect)

        this.once(['on', connect.replace('_', ''), 'edError_Event'].join(''), (error: any) => {
          this.connected = false;
          this.onConnect.next(false)
          this.signalR.log('AppLog_Info', {
            message: `connect error`,
            metadata: {
              connect,
              error
            }
          })
          // retry?
          setTimeout(() => {
            resolve(this.connect())
          }, 1000 * 10);
        })
        this.once(['on', connect.replace('_', ''), 'ed_Event'].join(''), () => {
          this.signalR.log('AppLog_Info', {
            message: `connect success`,
            metadata: {
              connect,
            }
          })
          resolve(this.init(true))
        })
        this.callMethodSync(connect)
          .then((_) => {
            this.onConnect.next(true)
            this.connected = true
            resolve(true)
            // what now?
            // return this.init(true)
          }).catch((error) => {
            reject(error)
          })
      })
    }
    return new Promise((resolve, reject) => {
      this.connected = true;
      this.onConnect.next(true);
      resolve(true)
    })
  }

  private init(response: boolean) {
    this.connected = response;
    this.onConnect.next(response)
    this.deferred_list.map((action) => {
      this.signalR.log('AppLog_Info', {
        message: `${action.name} is being called from deferred list`,
        metadata: {
          CompIdx: this.CompIdx, DeviceManagerInterface: this.DeviceManagerInterface, parameters: action.parameters
        }
      })
      this.callMethodSync.call(this, action.name, ...action.parameters).then((_response) => {
        action.resolve(_response)
      }).catch((_error) => {
        action.reject(_error)
      })
    })
    return Promise.resolve(response)
  }

  public disconnect() {
    let connect = {
      "IO_Module": "iOModule_Disconnect",
      "Barcode_Scanner": "barcodeScanner_Disconnect",
      "Bill_Dispenser": "billDispenser_Disconnect",
      "Bill_Acceptor": "billAcceptor_Disconnect",
      "PinPad": "pinPad_Disconnect",
      "MagstripeReader": "MagstripeReader_Disconnect",
    }[this.moduleId] || ""
    if (connect) {
      return this.callMethod(connect);
    }
    return new Promise((resolve, reject) => { resolve(true) })
  }

  public fakeTrigger(name: string, event: any) {
    this.mocked_listeners.filter((listener: any) => {
      return listener.e.toLowerCase() == name.toLowerCase()
    }).map((listener: any) => {
      listener.cb(event)
    })
    this.mocked_once_listeners = this.mocked_once_listeners.filter((listener: any) => {
      if (listener.e.toLowerCase() == name.toLowerCase()) {
        listener.cb(event)
      }
      return listener.e.toLowerCase() != name.toLowerCase()
    })
  }

  public on(e: string, cb: any, log: boolean = true) {
    if (this.config.KIOSK_ENABLED) {
      if (this.hubProxy) {
        if (log) {
          this.signalR.log('AppLog_Info', {
            message: `${e} on`,
            metadata: null
          })
        }
        this.hubProxy.on(e, (event: any) => {
          if (log) {
            this.signalR.log('AppLog_Info', {
              message: `${e} event is received`,
              metadata: {
                event
              }
            })
          }
          this.ngZone.run(() => cb.call(this, event));
        })
      } else {
        this.listeners.push({ e, cb })
      }
    } else {
      this.mocked_listeners.push({ e, cb })
    }
    return this;
  }

  public once(e: string, cb: any) {
    if (this.config.KIOSK_ENABLED) {
      if (this.hubProxy) {
        this.signalR.log('AppLog_Info', {
          message: `${e} once`,
          metadata: null
        })
        let _cb = (event: any) => {
          this.signalR.log('AppLog_Info', {
            message: `${e} event is received`,
            metadata: {
              event
            }
          })
          this.ngZone.run(() => cb.call(this, event));
          this.off(e, _cb)
        }
        this.hubProxy.on(e, _cb)
      } else {
        this.once_listeners.push({ e, cb })
      }
    } else {
      this.mocked_once_listeners.push({ e, cb })
    }
    return this;
  }

  public off(e: string, cb?: any) {
    if (this.config.KIOSK_ENABLED) {
      if (this.hubProxy) {
        this.signalR.log('AppLog_Info', {
          message: `${e} off`,
          metadata: null
        })
        this.hubProxy.off(e, cb);
      } else {
        this.listeners = this.listeners.filter((listener: any) => {
          return !(listener.e.toLowerCase() == e.toLowerCase() && listener.cb.toString() == cb.toString())
        })
      }
    } else {
      this.mocked_listeners = this.mocked_listeners.filter((listener: any) => {
        return cb && !(listener.e.toLowerCase() == e.toLowerCase() && listener.cb.toString() == cb.toString())
      })
    }
    return this;
  }

  public setData(idx: any, interf: any) {
    this.CompIdx = idx;
    this.DeviceManagerInterface = interf;
  }

  public setHub(hub: any) {
    this.hubProxy = hub;
  }

  public callMethodSync(name: string, ...parameters: any): Promise<any> {
    return new Promise((resolve, reject) => {
      if (this.config.KIOSK_ENABLED) {
        this.signalR.log('AppLog_Info', {
          message: `${name} is called`,
          metadata: {
            CompIdx: this.CompIdx, DeviceManagerInterface: this.DeviceManagerInterface, parameters
          }
        })
        this.hubProxy.invoke.call(this.hubProxy, ...[name, this.CompIdx, this.DeviceManagerInterface, ...parameters]).then((response: any) => {
          this.signalR.log('AppLog_Info', {
            message: `${name} completed`,
            metadata: {
              response
            }
          })
          resolve(response)
        }).catch((error: any) => {
          this.signalR.log('AppLog_Error', {
            message: `${name} failed`,
            metadata: {
              error
            }
          })
          reject(error)
        })
      } else {
        this.signalR.log('AppLog_Error', {
          message: `Failed to call ${name} `,
          metadata: {
            custom_error: "kiosk invoke disabled"
          }
        })
        reject({ name, parameters, bypass: true, message: 'kiosk invoke disabled' })
      }
    });
  }

  public callMethod(name: string, ...parameters: any): Promise<any> {
    if (this.connected || !this.config.KIOSK_ENABLED) {
      return this.callMethodSync.call(this, name, ...parameters)
    } else if (this.unavailable) {
      this.signalR.log('AppLog_Error', {
        message: `Failed to call ${name} `,
        metadata: {
          custom_error: name + ' disabled'
        }
      })
      return Promise.reject({ name, parameters, bypass: true, message: name + ' disabled' });
    } else {
      this.signalR.log('AppLog_Info', {
        message: `${name} call has been deferred`,
        metadata: {
          CompIdx: this.CompIdx, DeviceManagerInterface: this.DeviceManagerInterface, parameters
        }
      })
      let promise = new Promise((resolve, reject) => {
        this.deferred_list.push({ name, parameters, resolve: resolve.bind(this), reject: reject.bind(this) })
      });
      return promise;
    }
  }

  setUnavailable() {
    this.unavailable = true;
  }

}
